import { render } from "./PSV1Promotion.vue?vue&type=template&id=f2b8a384&scoped=true"
import script from "./PSV1Promotion.vue?vue&type=script&lang=js"
export * from "./PSV1Promotion.vue?vue&type=script&lang=js"

import "./PSV1Promotion.vue?vue&type=style&index=0&id=f2b8a384&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b8a384"]])

export default __exports__